module.exports = __webpack_public_path__ + "img/avp_bck_alt_phablet@2x.66a0767.jpg";